import { render, staticRenderFns } from "./button-cta.vue?vue&type=template&id=1b0494ab&"
import script from "./button-cta.vue?vue&type=script&lang=js&"
export * from "./button-cta.vue?vue&type=script&lang=js&"
import style0 from "./button-cta.vue?vue&type=style&index=0&id=1b0494ab&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports